<template>
<v-app>
    <div class="name_order_online_pick_up_user_page" :style="{background: bg_color}">
        <v-container>
            <v-row class="justify-center align-center h_full_name_order_online_pick_up_user">
                <v-col cols="11" sm="10" md="11" lg="5" xl="6">
                    <div>
                        <div class="logo_name_order_online_pick_up_user">
                            <img :src="beforeImage">
                        </div>
                        <!-- <h2 class="text-center title_name_order_online_pick_up_user mb-3">"สักหนึ่งประโยค ขอชื่อของลูกค้า"</h2> -->
                        <v-text-field label="กรุณากรอกชื่อก่อนสั่งซื้ออาหาร" class="w_input_name_order_online_pick_up_user" v-model="name" outlined required>
                        </v-text-field>
                        <v-text-field label="กรุณากรอกเบอร์โทรก่อนสั่งซื้ออาหาร" class="w_input_name_order_online_pick_up_user" v-model="tel" type="tel" maxlength="10" @keypress="isNumber($event)" onpaste="return false" outlined required>
                        </v-text-field>
                        <!-- <v-select label="กรุณาเลือกเวลารับอาหารก่อนสั่งซื้ออาหาร" class="w_input_name_order_online_pick_up_user" :items="$store.state.timeOrderOnlinepickUpList" v-model="time" outlined required>
                        </v-select> -->
                        <v-text-field label="กรุณาเลือกเวลารับอาหารก่อนสั่งซื้ออาหาร" class="w_input_name_order_online_pick_up_user" v-model="time" outlined required>
                        </v-text-field>
                        <div class="error--text text-center mb-3 note_name_order_online_pick_up_user">
                            *หมายเหตุ ร้านเปิดให้บริการ 17.00 - 23.00 น. (หยุดทุกวัน พุธ)*
                        </div>
                        <v-btn rounded color="white" width="100%" height="65" @click="addCartOrderOnlineNameUser()">สั่งอาหาร</v-btn>
                    </div>
                </v-col>
            </v-row>
        </v-container>

    </div>
</v-app>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import before_image from "@/assets/new_logo_by.png";
export default {
    name: 'nameOrderOnlinePickUp',
    data() {
        return {
            beforeImage: before_image,
            bg_color: 'linear-gradient(to top, #038cc1 , #55c0e9)',
            name: '',
            tel: '',
            time: null,
        }
    },
    methods: {
        async colorRestaurant() {
            HTTP.get(`/showColor?store_id=${this.$route.query.store_id}&token=`+this.$route.params.token)
                .then((response) => {
                    if (response.data.successful === true) {
                        this.bg_color = response.data.color_code
                        this.beforeImage = response.data.logo_image
                        this.loading_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                    if (error.response.status === 500) {
                        // this.$router.push('/nametakeoutuser')
                    }

                })
        },
        async checkCartOrderOnlineNameUser() {
            if (this.$store.state.cartOrderOnlineNameUser !== null) {
                this.$router.push('/orderonlinepickup')
            }
        },
        async isNumber(evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async addCartOrderOnlineNameUser() {
            const regex = this.name.replace(this.$store.state.checkEmoji, "")
            const regex_time = this.time.replace(this.$store.state.checkEmoji, "")
            if (regex && this.tel && regex_time) {
                const namePage = {
                    name: regex,
                    tel: this.tel,
                    time: regex_time,
                }
                this.$store.commit('addCartOrderOnlineNameUser', namePage)
                this.$router.push('/orderonlinepickup')
            }
        }
    },
    mounted() {
        this.colorRestaurant()
        this.checkCartOrderOnlineNameUser()
    }
}
</script>

<style scoped>
.name_order_online_pick_up_user_page {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    background: #fdbd10;
}

.h_full_name_order_online_pick_up_user {
    height: 100%;
}

.logo_name_order_online_pick_up_user {
    width: 300px;
    margin: auto;
}

.logo_name_order_online_pick_up_user>img {
    max-width: 100%;
}

.title_name_order_online_pick_up_user {
    color: #fff;
}

.w_input_name_order_online_pick_up_user {
    width: 80%;
    margin: auto;
}

.w_input_name_order_online_pick_up_user>>>input {
    text-align: center;
    color: #000;
    caret-color: #000;
}

.w_input_name_order_online_pick_up_user>>>fieldset {
    color: #000 !important;
    background: #fff;
}

.w_input_name_order_online_pick_up_user>>>label {
    color: #000 !important;
}

.w_input_name_order_online_pick_up_user>>>i {
    color: #000 !important;
}

.note_name_order_online_pick_up_user {
    font-size: 17px;
}

@media only screen and (max-width: 625px) {
    .w_input_name_order_online_pick_up_user>>>label {
        font-size: 19px !important;
    }
}

@media only screen and (max-width: 545px) {
    .w_input_name_order_online_pick_up_user>>>label {
        font-size: 17px !important;
    }
}

@media only screen and (max-width: 495px) {
    .w_input_name_order_online_pick_up_user>>>label {
        font-size: 15px !important;
    }
}

@media only screen and (max-width: 445px) {
    .w_input_name_order_online_pick_up_user>>>label {
        font-size: 13px !important;
    }
}

@media only screen and (max-width: 400px) {
    .w_input_name_order_online_pick_up_user>>>label {
        font-size: 12px !important;
    }
}

@media only screen and (max-width: 375px) {
    .w_input_name_order_online_pick_up_user>>>label {
        font-size: 11px !important;
    }
}

@media only screen and (max-width: 345px) {
    .logo_name_order_online_pick_up_user {
        width: 100%;
    }

    .w_input_name_order_online_pick_up_user>>>label {
        font-size: 8px !important;
    }
}
</style>
